<div *ngIf="showLabelAtTop" class="d-flex justify-content-between px-2">
  <p>{{ label }}</p>
  <p *ngIf="!showInfinityProgressBar">
    {{ currentProgress | number : '1.0-2' }}%
  </p>
</div>
<div
  *ngIf="!showInfinityProgressBar"
  class="progress"
  style.height="{{ height }}px"
>
  <div
    class="progress-bar"
    [class.progress-bar-striped]="showStripes"
    [class.progress-bar-animated]="animate"
    role="progressbar"
    attr.aria-valuenow="{{ currentProgress }}"
    style.height="{{ height }}px"
    style.width="{{ currentProgress }}%"
    style.color="{{ labelColour }}"
    style.background="{{ progressBarColor }}"
  >
    {{ !showLabelAtTop ? label : '' }}
  </div>
</div>

<div *ngIf="showInfinityProgressBar" class="prgress-bar-container">
  <div class="infinity-progress-bar" style.height="{{ height }}px">
    <div
      class="infinity-progress-bar-value"
      style.background-color="{{ progressBarColor }}"
    ></div>
  </div>
</div>
